import { render, staticRenderFns } from "./ExamWatchFilters.vue?vue&type=template&id=87e805e6&scoped=true&"
import script from "./ExamWatchFilters.vue?vue&type=script&lang=js&"
export * from "./ExamWatchFilters.vue?vue&type=script&lang=js&"
import style0 from "./ExamWatchFilters.vue?vue&type=style&index=0&id=87e805e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e805e6",
  null
  
)

export default component.exports